/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Row, Col } from 'reactstrap';

import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import logo from './img/logo.png'
import LoginForm from './LoginForm';

const Login = ({ location, translate }) => {
  useEffect(() => {
    document.title = 'Sky MX - Login';
    document.body.style.backgroundColor = '#0f144a';
  });
  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);
  const _validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type)
      return false;
    return true;
  }

  return (
    <Container fluid={true} className="skymx-body">
      <div className="row h-100">
        <div className="col-sm-12">
        <Row>
        <Col sm="12">
          <img src={logo} alt="logo" className="logo-skymx" />
          <hr className='logo-line'/>
        </Col>
        </Row>
          <Row>
            <Col sm="3"></Col>
            <Col sm="6">
              {
                _validateParams()
                  ?
                  <>
                    <LoginForm
                      api={api}
                      location={location}
                    />
                  </>
                  : <RequestLoginErrorMessage
                    onlyMessage={true}
                    message={translate('RequestLoginErrorMessage')}
                  />
              }
            </Col>
            <Col sm="3"></Col>
          </Row>
        </div>
      </div>
    </Container>
  );
}

export default Login;
